module.exports = __webpack_public_path__ + "img/Skizze4.bbf6ed7c.jpg";